import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

const LanguageSwitcher = () => {
  const { t, i18n } = useTranslation();
  const currentLanguage = (i18n.resolvedLanguage || i18n.language || 'es').split('-')[0];
  const isSpanish = currentLanguage === 'es';
  const nextLanguageLabel = isSpanish ? t('language.english') : t('language.spanish');
  const buttonLabel = isSpanish ? 'EN' : 'ES';

  useEffect(() => {
    document.documentElement.lang = currentLanguage;
    localStorage.setItem('language', currentLanguage);
  }, [currentLanguage]);

  const toggleLanguage = () => {
    const newLang = isSpanish ? 'en' : 'es';
    i18n.changeLanguage(newLang).then(() => {
      document.documentElement.lang = newLang;
      localStorage.setItem('language', newLang);
    });
  };

  return (
    <button
      type="button"
      onClick={toggleLanguage}
      aria-label={t('language.translateTo', { language: nextLanguageLabel })}
      title={t('language.translateTo', { language: nextLanguageLabel })}
      className="inline-flex min-h-[44px] items-center gap-2 rounded-lg border-2 border-cyan-400/60 bg-cyan-500/15 px-5 py-2.5 text-white shadow-lg shadow-cyan-500/20 transition-all duration-300 hover:border-cyan-300 hover:bg-cyan-500/25 focus:outline-none focus:ring-2 focus:ring-cyan-300 focus:ring-offset-2 focus:ring-offset-zinc-950"
    >
      <span className="material-symbols-outlined text-[22px]">translate</span>
      <span className="text-sm font-bold uppercase tracking-wide">{buttonLabel}</span>
      <span className="hidden text-base font-semibold md:inline">{nextLanguageLabel}</span>
    </button>
  );
};

export default LanguageSwitcher;
